import { defineStore } from 'pinia';

// 定义用户信息接口
interface UserInfo {
  area: string;
  enterpriseAccountType: string | null;
  enterpriseId: string | null;
  enterpriseName: string | null;
  head: string;
  imageTimbreCustomStatus: boolean;
  lastLoginTime: string;
  memberBenefitId: string;
  memberBenefitName: string | null;
  memberEffectTime: string | null;
  memberExpiresTime: string | null;
  nickname: string;
  official: boolean;
  openLiveStatus: boolean;
  openid: string | null;
  phone: string;
  profession: string;
  remark: string | null;
  soundCloneStatus: boolean;
  status: boolean;
  systemType: number;
  teamId: string;
  tokenExpires: string;
  trade: string;
  unionid: string | null;
  userId: string;
  userRoleCode: string;
  userRoleId: string;
  userRoleName: string;
  username: string;
}

// 定义初始用户数据
const initialUserState: UserInfo = {
  area: '',
  enterpriseAccountType: null,
  enterpriseId: null,
  enterpriseName: null,
  head: '',
  imageTimbreCustomStatus: false,
  lastLoginTime: '',
  memberBenefitId: '',
  memberBenefitName: null,
  memberEffectTime: null,
  memberExpiresTime: null,
  nickname: '',
  official: false,
  openLiveStatus: false,
  openid: null,
  phone: '',
  profession: '',
  remark: null,
  soundCloneStatus: false,
  status: false,
  systemType: 2,
  teamId: '',
  tokenExpires: '',
  trade: '',
  unionid: null,
  userId: '',
  userRoleCode: '',
  userRoleId: '',
  userRoleName: '',
  username: '',
};

// 修改 Store 的定义，直接使用 UserInfo 作为 state
export const useUserStore = defineStore('userStore', {
  state: (): UserInfo => ({
    ...initialUserState,
  }),
  getters: {
    getUserInfo: (state) => state,
  },
  actions: {
    setUserInfo(info: Partial<UserInfo>) {
      Object.assign(this, info);
    },

    resetStore() {
      Object.assign(this, initialUserState);
    },

    updateUserField<K extends keyof UserInfo>(key: K, value: UserInfo[K]) {
      (this as UserInfo)[key] = value;
    },
  },

  persist: {
    key: 'userInfo',
    storage: localStorage,
  },
});
